module.exports = __webpack_public_path__ + "4c4de3a2b06fad4db174acb0d6463be8.MP3";